
<script>
	import { Router, Route } from 'svelte-routing';
	import { bootstrap_app } from './services/service-bootstrapping';
	import { logged_in } from './app-store';
	import env from './environment.js';

	// Frame components
	import Sidebar from './frame-components/sidebar.svelte';
	import Header from './frame-components/header.svelte';
	import ChatManager from './frame-components/chat-manager.svelte';

	// Pages anonymous area
	import LoginComponent from './pages/login-flow/login.svelte';
	import OtpComponent from './pages/login-flow/otp.svelte';

	// Pages logged in area
	import NewDraft from './pages/draft-flow/new-draft/new-draft.svelte';
	import Project from './pages/draft-flow/project/project.svelte';
	import ProjectListComponent from './pages/dashboard/project-list.svelte';
	import ArticleListLoaderComponent from './pages/draft-flow/article-list-loader.svelte';
	import ArticleListComponent from './pages/draft-flow/article-list.svelte';
	import ArticleContentLoader from './pages/draft-flow/article-content-loader/article-content-loader.svelte';
	import ArticleContent from './pages/draft-flow/article-content.svelte';
	import NotFound from './pages/not-found.svelte';

	let app_bootstraped = false;

	bootstrap_app(() => {
		app_bootstraped = true;
	});

</script>

<div style="display: none;">{env.apiUrl}</div>

<Header />
<Sidebar />
{#if !$logged_in}
	{#if app_bootstraped}
		<Router basepath="/">
			<Route path="/" component={LoginComponent} />
			<Route path="login" component={LoginComponent} />
			<Route path="otp/:email" component={OtpComponent} let:params>
				<OtpComponent email={params.email} />
			</Route>
			<Route path="*" component={LoginComponent} />
		</Router>
	{/if}
{:else}
	<!--
		should let other components load first due global dependencies
		eg: ChatManager/Sidebar
	 -->
	{#if app_bootstraped}
		<Router basepath="/">
			<Route path="/" component={ProjectListComponent} />
			<Route path="project-list" component={ProjectListComponent} />
			<Route path="project/:project_ref/" let:params>
				<Project params={params} />
			</Route>
			<Route path="new-draft/:project_ref/:draft_refcode" let:params>
				<NewDraft params={params} />
			</Route>
			<Route path="article-list-loader/:project_ref/:draft_refcode" let:params>
				<ArticleListLoaderComponent params={params} />
			</Route>
			<Route path="article-list/:project_ref/:draft_refcode" let:params>
				<ArticleListComponent params={params} />
			</Route>
			<Route path="article-content-loader/:project_ref/:draft_refcode" let:params>
				<ArticleContentLoader params={params} />
			</Route>
			<Route path="article-content/:project_ref/:draft_refcode" let:params>
				<ArticleContent params={params} />
			</Route>
			<Route path="*" component={NotFound} />
		</Router>
	{/if}
{/if}
<ChatManager />
